import { Edit, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";

export const BotAffiliateUpdate = () => {
  const {
    saveButtonProps,
    register,
    formState: { errors },
  } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("bot_affiliate_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_affiliate_id}
          helperText={(errors as any)?.bot_affiliate_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="BotAffiliate Id"
          name="bot_affiliate_id"
        />
        <TextField
          {...register("bot_exchange_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.bot_exchange_id}
          helperText={(errors as any)?.bot_exchange_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Bot Exchange Id"
          name="bot_exchange_id"
        />
        <TextField
          {...register("credential_account_id", {
            required: "This field is required",
          })}
          required
          error={!!(errors as any)?.credential_account_id}
          helperText={(errors as any)?.credential_account_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Credential Account Id"
          name="credential_account_id"
        />
      </Box>
    </Edit>
  );
};
